import { system } from "styled-system";
var heightConfig = {
  property: "height",
  scale: "sizes"
};
export var height = system({
  height: heightConfig
});
export default height;